<nz-modal [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="'100%'" nzCentered
  [nzVisible]="isVisibleInvestmentDrawer" [nzTitle]="investmentModalTitleTemp"
  nzClassName="investment-modal new-investment-modal" [nzFooter]="footerTpl" (nzOnCancel)="handleCancel(null)">
  <ng-template #investmentModalTitleTemp>
    <div class="d-flex">
    <div>{{investmentModalTitle}}</div>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <div style="min-height: 100%; min-width: 100%; overflow: auto;max-height: 100%;max-width: 100%;" cdkScrollable
      #modalBodyContainer>
      <nz-steps [nzCurrent]="current" class="step-box">
        <nz-step class="step-one" [nzTitle]="selectedData ? 'Investment' : 'New Investment'"></nz-step>
        <nz-step class="step-two" nzTitle="Investment Review"></nz-step>
      </nz-steps>
      <div class="steps-content mt-2">
        <div nz-row *ngIf="index=='First-content'">
          <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
            <div class="p-1">
              <div class="info-label mb-2">{{siteDetails?.Name}}</div>
              <form nz-form [formGroup]="_fS.investmentForm">
                <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                  <div nz-col [nzSpan]="canAddInvestor ? '18' : '24'">
                    <nz-form-item>
                      <nz-form-control [nzErrorTip]="investorError">
                        <label class="label-text required">Select investor</label>
                        <nz-select nzShowSearch nzPlaceHolder="Select Investor" [nzSize]="'default'"
                          formControlName="investor"  [nzSelectOnTab]="true" [nzCustomTemplate]="showCurrentTempInvestor"
                          (ngModelChange)="fetchInvestorHistory($event);getInvestmentHistory($event)">
                          <nz-option *ngFor="let option of listOfInvestors" nzCustomContent
                            [nzLabel]="option.CompanyName + ' | ' + option.InvestorDisplayName" [nzValue]="option._id">
                            <span>{{option.CompanyName + ' | ' + option.InvestorDisplayName}}
                            <span *ngIf="siteNonAlcStatus && option.IsNonAlc" class="program-box ml-1"> Non-alc </span></span>
                          </nz-option>
                          <ng-template #showCurrentTempInvestor let-selected>
                            <span>{{ selected.nzLabel }}
                                <span *ngIf="siteNonAlcStatus && currentInvestorNonAlcStatus" class="program-box"> Non-alc </span>
                            </span>
                          </ng-template>
                        </nz-select>
                        <ng-template #investorError let-control>
                          <ng-container *ngIf="control.hasError('required')">Please select investor</ng-container>
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="canAddInvestor ? '6' : ''">
                    <button nz-button nzBlock nzType="default" *ngIf="canAddInvestor" class="default-btn width-100 mr-1 mt-3"
                      (click)="createNewInvestor()">Create New</button>
                  </div>
                  <div nz-col nzSpan="24" *ngIf="siteDetails?.IsProgramPeriodVisible != null ? siteDetails?.IsProgramPeriodVisible : true">
                    <nz-form-item>
                      <nz-form-control [nzErrorTip]="programError">
                        <div class="d-flex align-i-c justify-content-space-between"> <label
                            class="label-text required">Select Program period</label><span class="span-text"
                            *ngIf="canAddProgramTag" (click)="manageProgramPeriod()">Manage</span></div>
                        <nz-select #programPeriod nzShowSearch nzPlaceHolder="Select Program Period" [nzSize]="'default'"
                          formControlName="programPeriod" (ngModelChange)="programPeriodChange($event)" [nzSelectOnTab]="true" 
                          [nzCustomTemplate]="showCurrentTemp" (nzFocus)="this._cS.programsListObserver.next('call');"
                          [nzAllowClear]="true">
                          <ng-container *ngFor="let option of listOfProgramPeriods">
                            <nz-option *ngIf="!_cS.isLoadingPrograms" [nzLabel]="option.label" [nzValue]="option.id">
                            </nz-option>
                          </ng-container>
                          <nz-option *ngIf="_cS.isLoadingPrograms" nzCustomContent nzDisabled>
                            <span nz-icon nzType="loading" class="loading-icon"></span>
                            Loading Data...
                          </nz-option>
                        </nz-select>
                        <ng-template #showCurrentTemp let-selected>
                          <span>{{ selected.nzLabel }}
                            <span [ngClass]="selectedProgram?.id == currentDefaultProgram?.id ? 'program-box' : ''">
                              {{selectedProgram?.id == currentDefaultProgram?.id ? 'Current Program' : ''}}</span>
                          </span>
                        </ng-template>
                        <ng-template #programError let-control>
                          <ng-container *ngIf="control.hasError('required')">Please select program period</ng-container>
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzSpan="24">
                    <nz-form-item>
                      <nz-form-control [nzErrorTip]="amountError">
                        <label class="label-text required">Amount</label>
                        <input #amount autocomplete="off" class="input-group" nz-input formControlName="amount"
                          placeholder="Enter Amount"
                          (keypress)="_cS.checkDecimalNumbers($event, _fS.investmentForm.get('amount').value)"
                          (blur)="formatAmount(_fS.investmentForm.get('amount').value)" maxlength="13" />
                        <ng-template #amountError let-control>
                          <ng-container *ngIf="control.hasError('required')">Please enter amount
                          </ng-container>
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzSpan="24">
                    <nz-form-item>
                      <nz-form-control [nzErrorTip]="dateError">
                        <label class="label-text required">Scheduled date</label>
                        <nz-date-picker class="date-picker" [nzFormat]="'MM/dd/yyyy'" disab formControlName="scheduledDate"
                          [nzAllowClear]="false" nzPlaceHolder="Select Date" [nzDisabledDate]="disabledDate"
                          nzInputReadOnly>
                        </nz-date-picker>
                        <ng-template #dateError let-control>
                          <ng-container *ngIf="control.hasError('required')">Please select scheduled date</ng-container>
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzSpan="24">
                    <nz-form-item>
                      <nz-form-control [nzErrorTip]="descError">
                        <label class="label-text required">Description</label>
                        <input [value]="currentProductService?.name" disabled nz-input class="w-50">
                        <textarea class="mt-1" nz-input rows="3" formControlName="description" minlength="2"
                          placeholder="Enter Description" maxlength="4000"></textarea>
                          <ng-template #descError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter description</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Please enter at least 2 characters</ng-container>
                          </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </form>
              <div class="pl-2">
              <div *ngIf="currentInvestorData && !currentInvestorData.isInvoice" class="mt-2">
                <div class="estimate-msg-title">
                  Estimate required
                </div>
                <div class="estimate-msg">
                  This supplier will be sent an estimate prior to an invoice being issued. This process takes
                  approximately 2 additional weeks.
                </div>
              </div>
              <div *ngIf="currentInvestorData && currentInvestorData.supplierNotes" class="mt-1">
                <div class="estimate-msg-title">
                  Supplier notes
                </div>
                <div class="estimate-msg" style="white-space:pre-wrap" [innerHTML]="currentInvestorData.supplierNotes">
                </div>
              </div>
              <div class="mt-1" *ngIf="currentInvestorData">
                <div class="estimate-msg-title">
                  Supplier terms
                </div>
                <div class="estimate-msg">
                  <!-- Net {{netTerms}} -->
                  <!-- {{currentInvestorData?.terms?.name == null ? 'Net ' + netTerms : currentInvestorData?.terms?.name}} -->
                  {{ 'Net ' + netTerms }}
                </div>
              </div>
              <div *ngIf="currentInvestorData && currentInvestorData.fiscalStart">
                <div class="estimate-msg-title">
                  Fiscal start
                </div>
                <div class="estimate-msg">
                  {{currentInvestorData.fiscalStart + ' 1'}}
                </div>
              </div>
            </div>
            </div>
          </div>
          <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
            <div class="investment-history">
              <app-investor-history [investorSelected]="_fS.investmentForm.value.investor"
                [selectedData]="selectedData"></app-investor-history>
            </div>
          </div>
        </div>
        <div nz-row *ngIf="index=='Second-content'">

          <div nz-col nzSpan="12">
            <div class="company-detail-box">
              <div class="investment-label-text">Company:</div>
              <p class="investment-company-name"> {{currentInvestorData?.companyName}}</p>
              <div class="investment-label-text">Representative:</div>
              <p class="investment-company-name"> {{currentInvestorData?.investorDisplayName}}</p>
              <div class="investment-label-text">Schedule Date:</div>
              <div class="d-flex">
                <p class="investment-company-name"> {{_fS.investmentForm.get('scheduledDate').value | date :
                  'MM/dd/yyyy'}}
                </p><nz-tag class="showTags" *ngIf="isScheduledFuture">Future</nz-tag>
              </div>
              <div class="investment-label-text" *ngIf="_fS.investmentForm.get('description').value">Description:
              <!-- <p class="investment-company-name">{{_fS.investmentForm.get('description').value}}</p> -->
              <div class="estimate-msg" style="white-space:pre-wrap" [innerHTML]="_fS.investmentForm.get('description').value">
              </div>
              </div>
            </div>
          </div>
          <div nz-col nzSpan="12">
            <div class="company-detail-box company-detail-second-box">
              <div class="d-flex align-i-c mb-1 justify-content-space-between">
                <p class="investment-label-text"> Estimated Arrival Date: <nz-tag class="br-5" [nzTooltipTitle]="!currentInvestorData.isInvoice ? 'The Estimated Delivery Date is '+  netTerms +' days + 2 weeks':''"
                  nzTooltipPlacement="bottomLeft" nz-tooltip>{{'Net' +
                    this.netTerms}}</nz-tag></p>
                <p class="investment-company-name pb-0">{{ estArrivalDate | date: 'MM/dd/yyyy'}}</p>
              </div>
              <div class="d-flex align-i-c mb-1 justify-content-space-between">
                <p class="investment-label-text"> Invoice Amount:</p>
                <p class="investment-company-name pb-0">{{ _fS.investmentForm.get('amount').value}}</p>
              </div>
              <div class="d-flex align-i-c mb-1 justify-content-space-between"
                *ngIf="((currentInvoiceAmount*currentProcessFee)/100) as variable">
                <p class="investment-label-text">Process Fee:</p>
                <p class="investment-company-name pb-0">${{variable | number: '1.2-2'}}</p>
              </div>
              <div class="d-flex align-i-c mb-1 justify-content-space-between"
                *ngIf="((currentInvoiceAmount*currentProcessFee)/100) as variable">
                <p class="investment-label-text">Net To Program:</p>
                <p class="investment-company-name pb-0">+${{(currentInvoiceAmount - variable) | number:
                  '1.2-2'}}</p>
              </div>
              <div class="d-flex align-i-c mb-1 justify-content-space-between" *ngIf="siteNonAlcStatus && currentInvestorNonAlcStatus"s>
                <p class="investment-label-text">Non-alc Credit:</p>
                <p class="investment-company-name pb-0">+{{currentInvoiceAmount | number}}</p>
              </div>
              <br/>
              <div class="d-flex align-i-c mb-1 justify-content-space-between" *ngIf="siteDetails?.IsProgramPeriodVisible != null ? siteDetails?.IsProgramPeriodVisible : true">
                <div class="d-flex">
                  <p class="investment-label-text">Program Period:</p><nz-tag class="br-5">{{ selectedProgram.id ==
                    currentDefaultProgram?.id ? 'Current' : 'Not Current'}}</nz-tag>
                </div>
                <p class="investment-company-name pb-0">{{selectedProgram.label}}</p>
              </div>
            </div>
          </div>
          <div class="comment-box">
            <div class="label-text mt-2">Additional comments and instructions for the accounting team</div>
            <textarea nz-input rows="3" [(ngModel)]="comment" placeholder="Enter comments" maxlength="4095"></textarea>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #footerTpl>
    <div class=" d-flex justify-content-end">
      <button nz-button nzType="default" class="default-btn width-100" (click)="handleCancel(null)">
        <span>Cancel</span>
      </button>
      <button nz-button nzType="default" class="default-btn width-100" (click)="pre()"
        *ngIf="current > 0">
        <span>Back</span>
      </button>
      <button nz-button nzType="primary" (click)="next()" *ngIf="current < 1" [disabled]="_cpS.isInvestmentHisoryLoading">
        <span>Next</span>
      </button>
      <button nz-button nzType="primary" (click)="done(true)" *ngIf="current === 1"
        [nzLoading]="isSubmittingInvestmentSummary" [disabled]="toBeGrayedOut" [ngClass]="toBeGrayedOut ? 'medium-btn cancel-btn' : ''">
        <span>Submit</span>
      </button>
      <button nz-button nzType="primary"
        (click)="selectedData && canDeleteInvestment ? isVisibleDeleteModal = true : done(false)" *ngIf="current === 1"
        [nzLoading]="isSubmittingInvestment">
        <span>{{selectedData && canDeleteInvestment ? 'Delete Investment': 'Submit and New' }}</span>
      </button>
    </div>
  </ng-template>
</nz-modal>

<!--modal to manage program period-->
<nz-drawer [nzVisible]="showProgramDrawer" (nzOnClose)="handleCancelProgram()" nzCentered
  [nzTitle]="'Manage Program Periods'" [nzWidth]="800" [nzMaskClosable]="false">
  <app-manage-programs *nzDrawerContent [isInvestmentModal]="isInvestmentModal"
    (newAddedProgram)="newAddedProgram($event)" (addUpdateProgram)="addUpdateProgram($event)"></app-manage-programs>
</nz-drawer>

<!--modal to create new investor-->
<nz-drawer [nzVisible]="showInvestorModal" (nzOnClose)="handleCancelInvestor()" [nzTitle]="'New Investor'"
  [nzWidth]="800" [nzMaskClosable]="false" nzClassName="investorModal investor-modal-box-main">
  <div *nzDrawerContent>
    <!-- padding -->
    <div class="">
      <h4 class="modal-sub-title">Search Investor Database</h4>
      <app-new-investor-vendor [userType]="'investor'" class="investor-search-box" [isAddEditPaymentScreen]="true"
        (newCreatedInvestor)="newCreatedInvestor($event)" (showVendorForm)="isInvestorFormVisible=true"></app-new-investor-vendor>
      <!-- <p class="or-text" *ngIf="isInvestorFormVisible">OR</p> -->
      <h4 class="modal-sub-title pt-20" *ngIf="isInvestorFormVisible">Create New Investor</h4>
    </div>
    <div class="drawer-box text-container" *ngIf="!isInvestorFormVisible">
      <div>
        Please search for the investor you wish to add. If you cannot find the investor, click on <strong style="white-space: pre;"> + Create New Investor</strong> at the bottom of the dropdown to manually input investor information.
      </div>
      </div>
    <app-add-investor-form *ngIf="isInvestorFormVisible" (investorData)="newCreatedInvestor($event)"></app-add-investor-form>
  </div>
</nz-drawer>

<nz-modal [(nzVisible)]="isVisibleDeleteModal" nzCentered [nzMaskClosable]="false" (nzOnCancel)="handleCancelDelete()">
  <div class="confirm-modal">
    <ng-container *nzModalContent class="cc">
      <div class="close-icon center">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </div>
      <h4 class="confirm-modal-title center ">Are You Sure?</h4>
      <p class="confirm-modal-sub-title center ">This Investment will be deleted and cannot be recovered. Are you sure
        you would like to continue?</p>
    </ng-container>
    <div *nzModalFooter class=" d-flex justify-content-end">
      <button nz-button nzType="default" (click)="handleCancelDelete()"
        class="default-btn width-100 ">Cancel</button>
      <button nz-button nzType="primary" (click)="deleteTransaction()" class=" medium-btn delete-btn width-100"
        [nzLoading]="isDeleting">Delete</button>
    </div>
  </div>
</nz-modal>